import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'

import Team from './modules/team'

Vue.use(Vuex)

const state = {
    message: '',
    env: process.env
}

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    actions,
    mutations,
    modules: {
        Team
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js